function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React, { cloneElement, useCallback } from 'react';
import PropTypes from 'prop-types';
import classNames, { classNamesFor } from '../../utils/classNames';
import Link from '../../Link';

var ProductTile = function ProductTile(props) {
  var className = props.className,
      discountBadge = props.discountBadge,
      gameArt = props.gameArt,
      linkArguments = props.linkArguments,
      linkHref = props.linkHref,
      price = props.price,
      productType = props.productType,
      productTypeText = props.productTypeText,
      productName = props.productName,
      qa = props.qa,
      renderLinkCallBack = props.renderLinkCallBack,
      serviceUpsell = props.serviceUpsell,
      targetId = props.targetId,
      type = props.type,
      forceShowProductType = props.forceShowProductType;

  var _ProductTile$getClass = ProductTile.getClassName({
    className: className,
    productType: productType
  }),
      root = _ProductTile$getClass.root,
      productTypeClass = _ProductTile$getClass.productType,
      nameClass = _ProductTile$getClass.productName;

  var showProductType = forceShowProductType || productType !== 'FULL_GAME' && productType !== 'BUNDLE';
  var renderTitle = /*#__PURE__*/React.createElement(Link, _extends({}, linkArguments, {
    href: linkHref
  }), /*#__PURE__*/React.createElement("span", {
    id: "product-name",
    "data-qa": "".concat(qa, "#product-name"),
    className: nameClass
  }, productName));
  var renderTitleLink = useCallback(function () {
    if (renderLinkCallBack) {
      return renderLinkCallBack(renderTitle, {
        type: type,
        target: targetId
      });
    }

    return renderTitle;
  }, [linkArguments, linkHref, nameClass, productName, renderLinkCallBack]);
  return /*#__PURE__*/React.createElement("div", {
    className: root,
    "data-qa": qa
  }, productName && renderTitleLink(), gameArt && /*#__PURE__*/cloneElement(gameArt, {
    qa: "".concat(qa, "#game-art"),
    className: classNames('psw-ally-indicator', 'psw-ally-indicator-gap-1', 'psw-show-on-hover', 'psw-b-0')
  }), showProductType && /*#__PURE__*/React.createElement("span", {
    "data-qa": "".concat(qa, "#product-type"),
    className: productTypeClass
  }, productTypeText), serviceUpsell && /*#__PURE__*/cloneElement(serviceUpsell, {
    qa: "".concat(qa, "#service-upsell")
  }), discountBadge && /*#__PURE__*/cloneElement(discountBadge, {
    qa: "".concat(qa, "#discount-badge"),
    className: 'psw-m-t-3 psw-m-b-2'
  }), price && /*#__PURE__*/cloneElement(price, {
    qa: "".concat(qa, "#price"),
    className: classNames('psw-fill-x', price.props.className)
  }));
};

var cx = classNamesFor(ProductTile);

ProductTile.getClassName = function (_ref) {
  var className = _ref.className,
      productType = _ref.productType;
  return {
    root: cx('psw-product-tile', 'psw-interactive-root', className),
    link: cx('psw-product-tile-link'),
    details: cx('psw-product-tile__details', 'psw-m-t-2'),
    productType: cx('psw-product-tile__product-type', 'psw-t-bold', 'psw-t-size-1', 'psw-c-t-2', 'psw-t-uppercase', 'psw-m-b-1', "".concat(productType && 'psw-m-t-2')),
    productName: cx('psw-t-body', 'psw-c-t-1', 'psw-t-truncate-2', 'psw-m-b-2')
  };
};

ProductTile.defaultProps = {
  className: '',
  discountBadge: null,
  linkArguments: {},
  linkHref: '/',
  qa: '',
  renderLinkCallBack: undefined,
  serviceUpsell: null,
  targetId: '',
  forceShowProductType: false
};
ProductTile.propTypes = {
  className: PropTypes.string,
  discountBadge: PropTypes.element,
  gameArt: PropTypes.element.isRequired,
  linkArguments: PropTypes.objectOf(PropTypes.string),
  linkHref: PropTypes.string,
  price: PropTypes.element.isRequired,
  // AKA StoreDisplayClassification
  // See: https://github.sie.sony.com/SIE-Private/arkham-gql/blob/28b71a3cbe0d765beb78f1e0595948a69acf7aa8/src/models/Catalog/enums.ts
  productType: PropTypes.string.isRequired,
  productTypeText: PropTypes.string.isRequired,
  productName: PropTypes.string.isRequired,
  qa: PropTypes.string,
  renderLinkCallBack: PropTypes.func,
  serviceUpsell: PropTypes.element,
  targetId: PropTypes.string,
  type: PropTypes.oneOf(['PRODUCT', 'CONCEPT']).isRequired,
  forceShowProductType: PropTypes.bool
};
export default ProductTile;